import Model from "../Model";

class BuildingGeneralBuilding extends Model {
    buildUrl ({query}) {
        return ['api/building/general-building'];
    }
};

export default new BuildingGeneralBuilding;